// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const foodEquipmentId = (z.number());
export const foodEquipment = z.object({
    id: foodEquipmentId,
    name: z.string(),
    deleted_at: z.date().nullable(),
    created_at: z.date(),
    deleted_by: operatorId.nullable(),
});
export const foodEquipmentInitializer = z.object({
    id: foodEquipmentId.optional(),
    name: z.string(),
    deleted_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    deleted_by: operatorId.optional().nullable(),
});
export const foodEquipmentMutator = z.object({
    id: foodEquipmentId.optional(),
    name: z.string().optional(),
    deleted_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FoodEquipment.js.map